import { useEffect, useState } from "react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";
import { WisdomAIOnboarding } from "./components/WisdomAIOnboarding";

export const WisdomAI = () => {
  const location = useLocation();
  useNavBarContext({ title: t("pageTitleOverride.wisdomAI") });
  const [isOnboardingOpen, setIsOnboardingOpen] = useState(true);

  useEffect(() => {
    setIsOnboardingOpen(true);
  }, [location.key]);

  return (
    <>
      <PageTitle title={t("pageTitle.wisdomAI")} />
      <WisdomAIOnboarding isOpen={isOnboardingOpen} onClose={() => setIsOnboardingOpen(false)} />
    </>
  );
};
